import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchActiveFiscMonth,
  fetchActiveFiscYear,
  fetchPrItem,
} from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";

const { TextArea } = Input;

const AddStaffTransactionModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeFiscYear, loading, activeFiscMonth, prItem } = useSelector(
    (state) => state.dropdown
  );
  const { saving } = useSelector((state) => state.save);

  const { personnelFolders } = useSelector((state) => state.folder);

  const [formData, setFormData] = useState(prodd);

  const [show,setShow] =  useState(false)
  const [show2,setShow2] =  useState(false)
  

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }
 
  const [value, setValue] = useState(prodd?.hasDailyRate || show || show2);

  const onChangeCheckbox = (e) => {
    if (e.target.checked) {
      setValue(1);
    } else {
      setValue(0);
    }
  };

  const onFinish = async (data) => {
    if (!formData?.ppId) {
      toast.error("Please select personnel");
      return;
    }
    if (!formData?.fpPyear) {
      toast.error("Please select year");
      return;
    }
    if (!formData?.fpPmonth) {
      toast.error("Please select month");
      return;
    }
    if (!formData?.stAmount) {
      toast.error("Please select amount");
      return;
    }

    const res = await dispatch(
      save({
        stId: prodd?.stId ? prodd?.stId : null,
        ppId: formData?.ppId,
        itemcode: formData?.itemcode,
        fpPyear: formData?.fpPyear,
        fpPmonth: formData?.fpPmonth,
        stAmount: formData?.stAmount,
        quantity:formData?.quantity,
        rate: formData?.rate,

        url: "hr/saveStaffItem.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await setShow(false)
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchPersonnelData(page, size) {
    dispatch(fetchPersonnelFolders());
  }

 

  async function fetchActiveFiscYearData() {
    dispatch(fetchActiveFiscYear());
  }

  async function fetchActiveFiscMonthData() {
    dispatch(fetchActiveFiscMonth());
  }

  const handleCalculateAmount = () => {
    const quantity = formData?.quantity || 0;
    const rate = formData?.rate || 0;
    let amount = quantity * rate;

    amount = Math.round(amount);
    setFormData((prev) => ({ ...prev, stAmount: amount }));
  };

  useEffect(() => {
    handleCalculateAmount();
  }, [formData?.quantity, formData?.rate]);

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  useEffect(() => {
    setValue(prodd?.hasDailyRate || show || show2);
  }, [prodd?.hasDailyRate || show || show2]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.ppFullname}` : "Add staff transaction"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label={<span>Staff</span>}
            rules={[
              {
                required: true,
                message: "Please select staff",
              },
            ]}
          >
            <Select
              name="ppId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                personnelFolders?.length > 0 &&
                personnelFolders?.map((item) => ({
                  value: item?.ppId,
                  label: item?.ppPfno + " - " + item?.ppFullname,
                }))
              }
              onChange={(value) => {
                const selectedItem = personnelFolders?.find((item) => item?.ppId === value);
                if (selectedItem?.hasDailyRate) { 
                  setShow(true)
                } else {
                  setShow(false)
                }
                handleSelectChange(value, "ppId");
              }}
              value={formData?.ppId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchPersonnelData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label="Item"
            rules={[
              {
                required: true,
                message: "Please select Item",
              },
            ]}
          >
            <Select
              name="itemcode"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                prItem?.length > 0 &&
                prItem?.map((item) => ({
                  value: item?.piItemcode,
                  label: item?.piItemname,
                }))
              }
              onChange={(value) => {
                const selectedItem = prItem?.find((item) => item?.piItemcode === value);
                if (selectedItem?.hasDailyRate) { 
                  setShow2(true)
                } else {
                  setShow2(false)
                }
                handleSelectChange(value, "itemcode");
              }}
              value={formData?.itemcode}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
             
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>
          <Form.Item
            className=""
            label="Period Year"
            rules={[
              {
                required: true,
                message: "Please select period year ",
              },
            ]}
          >
            <Select
              name="fpPyear"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                activeFiscYear?.length > 0 &&
                activeFiscYear?.map((item) => ({
                  value: item?.fpPyear,
                  label: item?.fpPyear,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "fpPyear");
              }}
              value={formData?.fpPyear}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchActiveFiscYearData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label="Period Month"
            rules={[
              {
                required: true,
                message: "Please select period month ",
              },
            ]}
          >
            <Select
              name="fpPmonth"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                activeFiscMonth?.length > 0 &&
                activeFiscMonth?.map((item) => ({
                  value: item?.fpPmonth,
                  label: item?.fpPmonth,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "fpPmonth");
              }}
              value={formData?.fpPmonth}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchActiveFiscMonthData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>
          {(prodd || (show && show2)) && (
            <>
              <Form.Item
                label="Has Daily Rate"
                rules={[
                  {
                    required: false,
                    message: "Enter Has Daily Rate",
                  },
                ]}
              >
                <Checkbox
                  disabled
                  name="hasDailyRate"
                  checked={value}
                  onChange={onChangeCheckbox}
                >
                  Has Daily Rate
                </Checkbox>
              </Form.Item>
              {value && (
                <>
                  <Form.Item
                    label="Quantity"
                    rules={[
                      {
                        required: true,
                        message: "Enter Quantity",
                      },
                    ]}
                  >
                    <InputNumber
                      name="quantity"
                      value={formData?.quantity}
                      onChange={(value) => onChangeOther(value, "quantity")}
                      parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                      className="input flex"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Rate"
                    rules={[
                      {
                        required: true,
                        message: "Enter Rate",
                      },
                    ]}
                  >
                    <InputNumber
                      name="rate"
                      value={formData?.rate}
                      onChange={(value) => onChangeOther(value, "rate")}
                      parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                      className="input flex"
                    />
                  </Form.Item>
                </>
              )}
            </>
          )}

          <Form.Item
            label="Amount"
            rules={[
              {
                required: true,
                message: "Enter Amount",
              },
            ]}
          >
            <InputNumber
              disabled={prodd?.hasDailyRate ? true : false}
              name="stAmount"
              value={formData?.stAmount}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "stAmount")}
              className="input flex"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddStaffTransactionModal;
